<template>
  <main-body>
    <div class="d-flex justify-end" style="font-size: small; margin-top: 0px; margin-bottom: 5px">
      총 건수: {{ summary.totalCount }},
      미발행 건수: {{ numberFormat(summary.missCount) }},
    </div>

    <div class="main-con">
      <!--매출 확인 버튼 클릭시 나오는 모달 시작-->
      <sales-modal :dialog="dialog" :sales-list-click-auto-setting-data="salesListClickAutoSettingData"
                   @close-modal="closeSalesModal"
      />

      <table class="data-table" style="table-layout: fixed">
        <thead style="z-index: 1">
        <tr>
          <th class="width-percent-4" style="cursor: pointer;" @click="sortOptionChange('rentalcompanyId')">
            업체코드
          </th>
          <th class="width-percent-8" style="cursor: pointer;" @click="sortOptionChange('rentalcompanyName')">
            업체명
          </th>
          <th class="width-percent-4" style="cursor: pointer;" @click="sortOptionChange('accountId')">
            거래처번호
          </th>
          <th class="width-percent-10" style="cursor: pointer;" @click="sortOptionChange('accountName')">
            거래처명
          </th>
          <th class="width-percent-4" style="cursor: pointer;" @click="sortOptionChange('contractFeeYn')">
            매출유형
          </th>
          <th class="width-percent-4" style="cursor: pointer;" @click="sortOptionChange('contractFee')">
            설정금액
          </th>
          <th class="width-percent-4" style="cursor: pointer;" @click="sortOptionChange('useYn')">
            자동화
          </th>
          <th class="width-percent-4" style="cursor: pointer;" @click="sortOptionChange('tmId')">
            설정정보
          </th>
          <th class="width-percent-4" style="cursor: pointer;" @click="sortOptionChange('autoYn')">
            세금계산서 자동화
          </th>
          <th class="width-percent-4" style="cursor: pointer;" @click="sortOptionChange('serviceType')">
            서비스 구분
          </th>
          <th class="width-percent-4" style="cursor: pointer;" @click="sortOptionChange('billingId')">
            매출
          </th>

          <th class="width-percent-4" style="cursor: pointer;" @click="sortOptionChange('billTaxSchDay')">
            매출 발행일
          </th>
          <th class="width-percent-4" style="cursor: pointer;" @click="sortOptionChange('billTmId')">
            매출 설정정보
          </th>
          <th class="width-percent-4" style="cursor: pointer;" @click="sortOptionChange('isResult')">
            발행여부
          </th>
          <th >
            메세지
          </th>
          <th class="width-pixel-80" />
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in items" :key="index" :style="markConditionStyle(index)" @click="openModal(item)">

          <template>
            <td class="table-text-center">
              {{ item.rentalcompanyId }}
            </td>
            <td :title="item.rentalcompanyName">
              {{ item.rentalcompanyName }}
            </td>
            <td class="table-text-center">
              {{ item.accountId }}
            </td>
            <td class="short-text" :title="item.accountName">
              {{ item.accountName }}
            </td>

            <td class="table-text-center" :title="item.contractFeeYn">
              {{ item.contractFeeYn === 'Y'? "거래처약정": "계약서별" }}
            </td>
            <td :title="item.contractFee" class="table-text-right" :style="{color: item.contractFee === '0.00'?'red':'black'}">
              {{ numberFormat(item.contractFee) }}
            </td>
            <td class="table-text-center" :style="{color: item.useYn !== 'Y'?'red':'black'}">
              {{ item.useYn === 'Y'?'사용':'미사용' }}
            </td>
            <td class="table-text-center" :style="{color: !!item.tmId?'black':'red'}">
              {{ !!item.tmId? item.tmId: '없음' }}
            </td>
            <td class="table-text-center" :style="{color: item.autoYn !== 'Y'?'red':'black'}">
              {{ item.autoYn === 'Y'?'사용':'미사용' }}
            </td>
            <td class="table-text-center" :style="{color: item.autoYn !== 'Y'?'red':'black'}">
              {{ item.serviceType === 'N'?'국세청':'팝빌' }}
            </td>
            <td class="table-text-center">
              {{ item.billingId }}
            </td>
            <td class="table-text-center">
              {{ item.billTaxSchDay }}
            </td>
            <td class="table-text-center">
              {{ item.billTmId }}
            </td>
            <td class="table-text-center">
              {{ item.isResult === 'Y'? '발행':'-' }}
            </td>

            <td>{{ item.message }}</td>

            <td v-if="searchOptions.batchType =='T' " class="table-text-center">
              <v-btn
                  color="primary"
                  dark
                  x-small
                  @click.stop="openSalesModal(item.rentalcompanyId,item.accountName)"
              >
                매출확인
              </v-btn>
            </td>
          </template>
        </tr>
        </tbody>
      </table>
    </div>
    <div
        class="infinity_scroll_table_paging"
    >
      <v-container>
        <v-row justify="center">
          <v-col cols="8">
            <v-container class="max-width">
              <v-pagination
                  v-model="page"
                  class="my-4"
                  :length="pageLength"
              />
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div v-show="isLoading" class="loading_wrap">
      <div class="loading" />
      <div class="loading" />
      <div class="loading" />
    </div>
  </main-body>


</template>


<script>
import {PATH} from "@/constants";
import MainBody from "@/components/common/layout/MainBody.vue";
import SalesModal from "@/views/batch/SalesModal.vue";

export default {
  name: "BatchCheckTaxComp",
  components: {
    SalesModal,
    MainBody,
  },
  props: {
    searchOptions: {
      type: Object
    },
    identifier: {
      type: Number
    }

  },
  data() {
    return {
      items: [],
      dialog: false,
      dataTotalCount: 0,
      summary: {
        totalCount:0,
        missCount: 0,
      },
      isLoading: false,
      page: 1,
      isSummaryLoading: false,
      sortOption: {
        sortBy: [],
        sortDesc: [],
      },
      salesListClickAutoSettingData: { //매출 확인 버튼 클릭시 전달할 데이터를 가공하기 위함입니다.
        rentalcompanyId: undefined,
        companyName: undefined
      },
    }
  },

  computed: {
    pageLength() {
      if (!this.dataTotalCount) return 1
      return Math.ceil(this.dataTotalCount / this.searchOptions.pageSize)
    },
  },
  watch: {
    'searchOptions.pageNumber'(newValue, oldValue) {
      this.page = newValue
    },
    page(newValue, oldValue) {
      this.onLoad(newValue)
    },
    'searchOptions.rentalcompanyId'(newVal) {
      this.onLoad(1)
    },
    identifier() {
      this.sortOption.sortBy = []
      this.sortOption.sortDesc = []
      this.onLoad(1)
    },
  },

  mounted() {
    this.onLoad(1)
  },

  methods: {
    openModal(item) {
      this.$emit('open-modal', {batchType: 'B', ...item})
      /*console.log('### item', item)
      this.isModal = true
      this.modalItem = item
      this.modalItem.detailReason = ""
      this.modalItem.batchType = item.batchType
      this.modalItem.baseDt = this.searchOptions.checkDate*/
    },
    closeSalesModal() {
      this.dialog = false
      // this.rentalcompanyId = undefined
    },
    openSalesModal(rentalId, companyName) {
      this.salesListClickAutoSettingData = {
        companyName: companyName,
        rentalcompanyId: !!rentalId ? Number(rentalId) : undefined
      }
      this.dialog = true
    },
    markConditionStyle(idx) {
      if (this.items[idx].besideCount > 1 || this.items[idx].usageCount > 1) {
        return {'backgroundColor': 'yellow'};
      }
    },
    sortOptionChange(e) {

      this.sortOption.sortBy[0] = e
      this.sortOption.sortDesc[0] = this.sortOption.sortDesc[0] === 'true'?'false': 'true'

      this.onLoad(1)

    },

    numberFormat(number) {
      if (!number) return '0'
      return Number(number).toLocaleString()
    },
    onSortChange(option) {
      Object.keys(option).forEach(e => {
        this.sortOption[e] = option[e]
      })
      this.onFilterChanged()
    },
    /**
     * 필터 변경
     */
    onFilterChanged() {
      this.onLoad(1)
    },

    onLoad(pageNumber) {
      this.searchOptions.pageNumber = pageNumber || 1
      this.items.splice(0, this.items.length)
      this.loadData()
      this.loadSummary()
    },
    async loadSummary() {

      this.isLoading = true
      this.$request(PATH.BATCH.TAX_CHECK_SUMMARY)
          .setObject(this.searchOptions)
          .catch(e => {
            this.isLoading = false;
            alert("조회 실패")
          })
          .enqueue()
          .then(res => {
            this.summary = res
            this.dataTotalCount = res.totalCount
          });
    },
    loadData() {

      this.isLoading = true
      this.$request(PATH.BATCH.TAX_CHECK)
          .setObject({...this.searchOptions, ...this.sortOption})
          .catch(e => {
            this.isLoading = false;
            alert("조회 실패")
          })
          .enqueue()
          .then(res => {
            this.items.push(...res.data)
            this.isLoading = false;
          });
    },

  },
}
</script>

<style scoped>
.main-con {
  position: relative;
  width: 100%;
  height: 92%;
  overflow-y: scroll;
}

.main-con .data-table {
  position: relative;
  width: 100%;
  border-spacing: 0;
}

.main-con .data-table thead {
  position: sticky;
  top: 0;
  background: #ddd;
}

.main-con .data-table thead tr th {
  font-size: 13px;
}

.main-con .data-table tbody td {
  padding: 0.15rem;
  text-align: left;
  border: 1px solid #ccc;
  font-size: 13px;
}

.main-con .data-table tbody tr:nth-child(even) {
  background: #f5f5f5;
}

.main-con .data-table tbody tr:hover {
  background: #ddd;
}

.infinity_scroll_table_paging {
  margin-top: 10px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.loading_wrap {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  background: rgba(0,0,0,0.5);
}
.loading {
  width: 8px;
  height: 8px;
  background: #aaaaaa;
  border-radius: 50%;
  animation: loading-cricle 1.5s infinite ease-in-out;
  display: inline-block;
  margin-right: 8px;
}

.loading:nth-child(2) {
  animation-delay: .5s;
}

.loading:nth-child(3) {
  animation-delay: 1s;
}
</style>
